export default "__VITE_ASSET__CeMJRxWq__"